module.exports = __webpack_public_path__ + "img/Group 28815.f93b6013.svg";